import { RESTAURANT_INFO, IMAGES } from "@/data/menuData";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          <div className="flex flex-col items-center md:items-start">
            <img src={IMAGES.logo} alt="Adrianoz Pizza" className="w-24 opacity-90" />
            <p className="font-['DM_Sans'] text-sm text-white/50 mt-3 text-center md:text-left max-w-xs">
              El mismo amor por la pizza, ahora más grande. Más de 30 años de experiencia.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-2">
            <a
              href={`tel:${RESTAURANT_INFO.phone}`}
              className="font-['DM_Sans'] text-sm text-white/60 hover:text-white transition-colors duration-300"
            >
              Tel: {RESTAURANT_INFO.phoneDisplay}
            </a>
            <a
              href={`https://wa.me/${RESTAURANT_INFO.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="font-['DM_Sans'] text-sm text-white/60 hover:text-white transition-colors duration-300"
            >
              WhatsApp: {RESTAURANT_INFO.whatsappDisplay}
            </a>
            <p className="font-['DM_Sans'] text-xs text-white/30 mt-4">
              &copy; {new Date().getFullYear()} Adrianoz Pizza. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
